<template>
  <div>
    <nomenclature-form
      :create="create"
      :view="view"
      :change="change"
      @close="$router.push('/client/nomenclature/list')"
      @list="$router.push('/client/nomenclature/list')"
      @change="id=> $router.push('/client/nomenclature/change?id=' + id)"
      @view="id=> $router.push('/client/nomenclature/view?id=' + id)"
    />
  </div>
</template>
<script >

import NomenclatureForm from "@/views/admin/components/Nomenclature-form.vue"

export default {
  components: { NomenclatureForm },
  props: ['create', 'change', 'view'],
  mounted () {
    console.log('Nomenclature-page.vue is loaded')
  },
}
</script>

<style scoped>

</style>
